/**
 * Created by ivo on 14.05.14.
 */

define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-widget/widgetFactory',
    'library/fcse-dropdown/dropdown',
    'library/fcse-ratingwidget/ratingWidget',
    'clientComponents/travelperiod/travelPeriodWidget',
    'clientComponents/travellers/travellersWidgetExtended',
    'library/fcse-flyout/flyout',
    'clientComponents/location/locationWidgetExtended',
    'clientComponents/destination/destinationWidgetExtended',
    'clientComponents/hotelsearch/hotelSearchWidget',
    'clientComponents/globaltype/globalTypeWidget',
    'clientComponents/checkbox/checkbox',
    'clientComponents/search/searchWidget',
    'clientComponents/airlinefilter/airlineFilterWidget',
    'clientComponents/extendedsearch/extendedSearchWidget',
    'clientComponents/priceslider/priceSliderWidget',
    'clientComponents/priceslider/priceSliderRangeWidget',
    'clientComponents/ratingslider/ratingSliderRangeWidget',
    'clientComponents/checklist/checklist',
    'library/fcse-tagbarwidget/tagbarWidget',
    'clientComponents/tagbarsearch/tagBarSearch'
    ],
    function($,
            _,
            Object,
            WidgetFactory,
            Dropdown,
            RatingWidget,
            TravelPeriodWidget,
            TravellersWidget,
            Flyout,
            LocationWidget,
            DestinationWidget,
            HotelSearchWidget,
            GlobalTypeWidget,
            CheckboxWidget,
            SearchWidget,
            AirlineFilterWidget,
            ExtendedSearchWidget,
            PriceSliderWidget,
            PriceSliderRangeWidget,
            RatingSliderRangeWidget,
            CheckList,
            TagBarWidget,
            TagBarSearch
    ) {


        /**
         * Abstract pseudo class for the creational process of
         * the filter widgets.
         *
         * @constructor
         * @param {Object} scope
         * @param array An array of widgets to be instantiated
         * @returns {_L1.WidgetFactory}
         */
        var AbstractWidgetFactory = function(scopes) {
            WidgetFactory.apply(this, arguments);
        };

        AbstractWidgetFactory.prototype = $.extend(Object.create(WidgetFactory.prototype), {
            /**
             * An array of active widget names, should be overwritten by subclass
             */
            _activeWidgets: [],

            /**
             * Creation process of widgets
             *
             * @returns {undefined}
             */
            _createWidgets: function() {
                var self = this;
                $.each(this._activeWidgets, function(index, name){
                    switch (name){
                        case 'board': {
                            self._createBoardWidget();
                            break;
                        }
                        case 'category': {
                            self._createCategoryWidget();
                            break;
                        }
                        case 'departureAirport': {
                            self._createDepartureAirportWidget();
                            break;
                        }
                        case 'destination': {
                            self._createDestinationWidget();
                            break;
                        }
                        case 'globalType': {
                            self._createGlobalTypeWidget();
                            break;
                        }
                        case 'price': {
                            self._createPriceWidget();
                            break;
                        }
                        case 'priceRange': {
                            self._createPriceRangeWidget();
                            break;
                        }
                        case 'rating': {
                            self._createRatingWidget();
                            break;
                        }
                        case 'ratingRange': {
                            self._createRatingRangeWidget();
                            break;
                        }
                        case 'room': {
                            self._createRoomWidget();
                            break;
                        }
                        case 'travellers': {
                            self._createTravellersWidget();
                            break;
                        }
                        case 'travelPeriod': {
                            self._createTravelPeriodWidget();
                            break;
                        }
                        case 'hotelSearch': {
                            self._createHotelSearchWidget();
                            break;
                        }
                        case 'redirectingHotelSearch': {
                            self._createRedirectingHotelSearchWidget();
                            break;
                        }
                        case 'headerHotelSearch': {
                            self._createHeaderHotelSearchWidget();
                            break;
                        }
                        case 'redirectingHeaderHotelSearch': {
                            self._createRedirectingHeaderHotelSearchWidget();
                            break;
                        }
                        case 'directFlight': {
                            self._createDirectFlightWidget();
                            break;
                        }
                        case 'headerSearch': {
                            self._createSearchWidget();
                            break;
                        }
                        case 'searchmaskSearch': {
                            self._createSearchmaskSearchWidget();
                            break;
                        }
                        case 'airlineFilter': {
                            self._createAirlineFilterWidget();
                            break;
                        }
                        case 'tourOperatorFilter': {
                            self._createTourOperatorFilterWidget();
                            break;
                        }
                        case 'extendedSearch': {
                            self._createExtendedSearchWidget();
                            break;
                        }
                        case 'hotelSearchTagBar': {
                            self._createHotelSearchTagBarWidget();
                            break;
                        }
                        default: {
                            throw new Error('Invalid widget name provided: "'+ name +'".');
                            break;
                        }
                    }
                });
            },

            /**
             * Creates the board widget
             * @private
             */
            _createBoardWidget: function(){
                // Board widget logic
                var boardWidget = new Dropdown('#widget-board');
                this.set('boardWidget', boardWidget);
            },

            /**
             * Creates the category widget
             * @private
             */
            _createCategoryWidget: function(){
                // Category widget logic
                var categoryWidget = new RatingWidget('#widget-category');
                this.set('categoryWidget', categoryWidget);                
            },

            /**
             * Creates the departure airport widget
             * @private
             */
            _createDepartureAirportWidget: function(){
                // Departure flyout
                var departureFlyout = new Flyout('#flyout-airport', {
                    closeOnOutsideClick: true,
                    submitOnOutsideClick: true
                });
                departureFlyout.setCaptionElement($('.widget--value-truncate', '.widget-airport'));
                departureFlyout.bindEventToCallerElement('click', $('.widget--btn, .widget--value', '.widget-airport'));

                // Departure widget
                var departureWidget = new LocationWidget('#widget-airport');
                departureFlyout.setWidget(departureWidget);
                this.set('departureWidget', departureWidget);                
            },

            /**
             * Creates the destination widget
             * @private
             */
            _createDestinationWidget: function(){
                // Destination flyout
                var destinationFlyout = new Flyout('#flyout-destination', {
                    closeOnOutsideClick: true,
                    submitOnOutsideClick: true
                });
                destinationFlyout.setCaptionElement($('.widget--value', '.widget-destination'));
                destinationFlyout.bindEventToCallerElement('click', $('.widget--btn, .widget--value', '.widget-destination'));

                // Destination widget
                var destinationWidget = new DestinationWidget('#widget-destination');
                destinationFlyout.setWidget(destinationWidget);
                this.set('destinationWidget', destinationWidget);                
            },
            
            /**
             * Creates global types widget
             * @private
             */
            _createGlobalTypeWidget: function(){
                // Create global types
                var globaltypeWidget = new GlobalTypeWidget('[data-fcse-role="globaltypewidget"]');
                this.set('globaltypeWidget', globaltypeWidget);                
            },

            /**
             * Creates the travellers widget
             * @private
             */
            _createTravellersWidget: function(){
                 //Travellers widget plus flyout
                var travellersFlyout = new Flyout('#flyout-travellers', {
                    closeOnOutsideClick: true,
                    submitOnOutsideClick: true
                });
                travellersFlyout.setCaptionElement($('[data-fcse-role="travellerswidget--caption"]', $('#button-travellers')));
                travellersFlyout.bindEventToCallerElement('click', $('#button-travellers'));
                
                var travellersWidget = new TravellersWidget('#widget-travellers', {
                    ensureEqualAdults: false
                });
                this.set('travellersWidget', travellersWidget);
                travellersFlyout.setWidget(travellersWidget);                
            },
            
            /**
             * Creates price widget
             * @private
             */
            _createPriceWidget: function(){
                // Price widget logic
                var priceWidget = new PriceSliderWidget('#widget-price');
                this.set('priceWidget', priceWidget);                
            },

            /**
             * Creates price range widget
             * @private
             */
            _createPriceRangeWidget: function(){
                // Price widget logic
                var priceWidget = new PriceSliderRangeWidget('#widget-price-range');
                this.set('priceRangeWidget', priceWidget);
            },

            /**
             * Creates the rating widget
             * @private
             */
            _createRatingWidget: function(){
                // Logic to create rating widget
                var ratingWidget = new RatingWidget('#widget-rating');
                this.set('ratingWidget', ratingWidget);
            },

            /**
             * Creates the rating range widget
             * @private
             */
            _createRatingRangeWidget: function(){
                var ratingWidget = new RatingSliderRangeWidget('#widget-rating-range');
                this.set('ratingRangeWidget', ratingWidget);
            },

            /**
             * Creates room widget
             * @private
             */
            _createRoomWidget: function(){
                // Room widget logic
                var roomWidget = new Dropdown('#widget-room');
                this.set('roomWidget', roomWidget);
            },

            /**
             * Creates travelperiod widget
             * @private
             */
//            _createTravelPeriodWidget: function(){
//                // Travelperiod widget logic
//                var travelPeriodWidget = new TravelPeriodWidget('#widget-travelperiod');
//                this.set('travelPeriodWidget', travelPeriodWidget);
//            },

            /**
             * Creates the travelperiod widget
             * @private
             */
            _createTravelPeriodWidget: function(){
                // Travelperiod flyout
                var travelPeriodFlyout = new Flyout('#flyout-travelperiod', {
                    closeOnOutsideClick: true,
                    submitOnOutsideClick: true
                });
                travelPeriodFlyout.setCaptionElement($('.widget--value', '.widget-travelperiod'));
                travelPeriodFlyout.bindEventToCallerElement('click', $('.widget--btn, .widget--value', '.widget-travelperiod'));

                // Travelperiod widget
                var travelPeriodWidget = new TravelPeriodWidget('#widget-travelperiod', {submitOn: ['periodTypeChange', 'durationChange']});
                travelPeriodFlyout.setWidget(travelPeriodWidget);
                this.set('travelPeriodWidget', travelPeriodWidget);
            },

            /**
             * Creates Hotelsearch widget
             * @private
             */
            _createHotelSearchWidget: function () {
                var hotelSearchWidget = new HotelSearchWidget('#widget-hotelsearch');
                this.set('hotelSearchWidget', hotelSearchWidget);
            },

            /**
             * Creates Redirecting Hotelsearch widget
             * @private
             */
            _createRedirectingHotelSearchWidget: function () {
                var hotelSearchWidget = new HotelSearchWidget('#widget-hotelsearch', {
                    rootScope: this._scopes.rootScope,
                    triggerRedirect: true
                });
                this.set('hotelSearchWidget', hotelSearchWidget);
            },

            /**
             * Creates Hotelsearch widget for header
             * @private
             */
            _createHeaderHotelSearchWidget: function () {
                var hotelSearchWidget = new HotelSearchWidget('#widget-headerhotelsearch');
                this.set('headerHotelSearchWidget', hotelSearchWidget);
            },

            /**
             * Creates Redirecting Hotelsearch widget for header
             * @private
             */
            _createRedirectingHeaderHotelSearchWidget: function () {
                var hotelSearchWidget = new HotelSearchWidget('#widget-headerhotelsearch', {
                    rootScope: this._scopes.rootScope,
                    triggerRedirect: true
                });
                this.set('headerHotelSearchWidget', hotelSearchWidget);
            },
            
            /**
             * Creates direct flight widget
             * @private
             */
            _createDirectFlightWidget: function() {
                if ($('#direct-flight').length > 0) {
                    var directFlight = new CheckboxWidget('#direct-flight');
                    this.set('directFlightWidget', directFlight);
                }
            },

            /**
             * Creates search widget
             * @private
             */
            _createSearchWidget: function() {
                if ($('#search-widget').length) {
                    var searchWidget = new SearchWidget('#search-widget', {rootScope: this._scopes.rootScope, useHeader: true}, this._scopes.localScope, true);
                    this.set('searchWidget', searchWidget);
                }
            },

            /**
             * Creates searchmask search widget
             * @private
             */
            _createSearchmaskSearchWidget: function() {
                if ($('#searchmask-search-widget').length) {
                    var searchWidget = new SearchWidget('#searchmask-search-widget',
                        {
                            rootScope: this._scopes.rootScope,
                            useHeader: true,
                            useRootScopeParams: ['groupNames', 'category', 'hotelAttributes']
                        },
                        this._scopes.localScope,
                        true);

                    this.set('searchmaskSearchWidget', searchWidget);
                }
            },

            /**
             * Creates airline filter widget
             * @private
             */
            _createAirlineFilterWidget: function() {
                var airlineFilterWidget = new AirlineFilterWidget('#widget-airlineFilter', {
                    rootScope: this._scopes.rootScope
                });
                this.set('airlineFilterWidget', airlineFilterWidget);
            },

            /**
             * Creates extended search widget
             * @private
             */
            _createExtendedSearchWidget: function() {
                var flyout = new Flyout('#flyout-extended-search', {
                    closeOnOutsideClick: true,
                    submitOnOutsideClick: true
                });
                flyout.bindEventToCallerElement('click', $('#button-extended-search'));

                var extendedSearchWidget = new ExtendedSearchWidget('#widget-extended-search', {scopes: this._scopes});
                flyout.setWidget(extendedSearchWidget);
                this.set('extendedSearchWidget', extendedSearchWidget);
            },

            _createHotelSearchTagBarWidget: function() {
                var tagBar = new TagBarWidget('#hotel-search-tagbar-bar');
                var hotelSearchTagBar = new TagBarSearch('#hotel-search-tagbar', {
                    rootScope: this._scopes.rootScope,
                    tagBarWidget: tagBar
                });
                this.set('hotelSearchTagBarWidget', hotelSearchTagBar);
            },

            _createTourOperatorFilterWidget: function() {
                var tourOperatorFlyout = new Flyout('#flyout-tourOperatorFilter', {
                    closeOnOutsideClick: true
                });
                tourOperatorFlyout.setCaptionElement($('.widget--value', '.widget-touroperator'));
                tourOperatorFlyout.bindEventToCallerElement('click', $('.widget--btn, .widget--value', '.widget-touroperator'));

                var tourOperatorWidget = new CheckList('#widget-tourOperatorFilter');
                tourOperatorFlyout.setWidget(tourOperatorWidget);
                this.set('tourOperatorWidget', tourOperatorWidget);
            },

            /**
             * Bind created widgets to the scope
             * @return {undefined}
             */
            _bindWidgetsToScope: function() {
                var self = this;
                $.each(this._activeWidgets, function(index, name){
                    switch (name){
                        case 'board': {
                            // Binding for board
                            self.get('boardWidget').bindToScope(self._scopes.rootScope, 'board');
                            break;
                        }
                        case 'category': {
                            // Binding for category
                            self.get('categoryWidget').bindToScope(self._scopes.rootScope, 'category');
                            break;
                        }
                        case 'departureAirport': {
                            // Binding for departure airport
                            self.get('departureWidget').bindToScope(self._scopes.rootScope, 'departureAirports');
                            break;
                        }
                        case 'destination': {
                            // Binding for destination
                            self.get('destinationWidget').bindToScope(self._scopes.rootScope, 'groupIds');
                            break;
                        }
                        case 'globalType': {
                            var globaltypeWidget = self.get('globaltypeWidget');
                            globaltypeWidget.bindToScope(self._scopes.rootScope, globaltypeWidget.getScopeBindingMap());
                            break;
                        }
                        case 'price': {
                            // Binding for price
                            self.get('priceWidget').bindToScope(self._scopes.rootScope, 'maxPrice');                            
                            break;
                        }
                        case 'priceRange': {
                            // Binding for price
                            self.get('priceRangeWidget').bindToScope(self._scopes.rootScope, {
                                'minPrice': '0',
                                'maxPrice': '1'
                            });
                            break;
                        }
                        case 'rating': {
                            // Binding for rating
                            self.get('ratingWidget').bindToScope(self._scopes.rootScope, 'rating');
                            break;
                        }
                        case 'ratingRange': {
                            // Binding for rating
                            self.get('ratingRangeWidget').bindToScope(self._scopes.rootScope, {
                                'minRating': '0',
                                'maxRating': '1'
                            });
                            break;
                        }
                        case 'room': {
                            // Binding for room
                            self.get('roomWidget').bindToScope(self._scopes.rootScope, 'room');
                            break;
                        }
                        case 'travellers': {
                            var i;
                            // Binding for travellers
                            self.get('travellersWidget').bindToScope(self._scopes.rootScope, 'travellers');
                            // clear params, whose were included into 
                            for (i in self._scopes.rootScope.params) {
                                if (i !== "travellers" && i.indexOf("travellers") === 0) {
                                    delete self._scopes.rootScope.params[i];
                                }
                            }
                            break;
                        }
                        case 'travelPeriod': {
                            // Binding for travel period
                            self.get('travelPeriodWidget').bindToScope(self._scopes.rootScope, {
                                    'departureDate': 'departureDate',
                                    'returnDate': 'returnDate',
                                    'duration': 'duration',
                                    'exactDepartureDate' : 'exactDepartureDate',
                                    'exactReturnDate' : 'exactReturnDate'
                            });
                            break;
                        }
                        case 'hotelSearch': // fall-through intended
                        case 'redirectingHotelSearch': {
                            // Binding for hotel name search
                            self.get('hotelSearchWidget').bindToScope(self._scopes.rootScope, 'hotelName');
                            break;
                        }
                        case 'headerHotelSearch':
                        case 'redirectingHeaderHotelSearch': {
                            // Binding for hotel name search
                            self.get('headerHotelSearchWidget').bindToScope(self._scopes.rootScope, 'hotelName');
                            break;
                        }
                        case 'directFlight': {
                            // Binding for stopOver
                            if (!_.isUndefined(self.get('directFlightWidget'))) {
                                self.get('directFlightWidget').bindToScope(self._scopes.rootScope, 'stopOver');
                            }
                            break;
                        }
                        case 'airlineFilter': {
                            self.get('airlineFilterWidget').bindToScope(self._scopes.rootScope, {
                                'airlineCodes': 'airlineCodes',
                                'excludedAirline': 'excludedAirline'
                            });
                            break;
                        }
                        case 'tourOperatorFilter': {
                            self.get('tourOperatorWidget').bindToScope(self._scopes.rootScope, 'tourOperators');
                            break;
                        }
                        case 'headerSearch': {
                            // Binding not needed
                            break;
                        }
                        case 'searchmaskSearch': {
                            if (self.get('searchmaskSearchWidget')) {
                                self.get('searchmaskSearchWidget').bindToScope(self._scopes.rootScope, {
                                    'hotelName': 'hotelName',
                                    'hotelId': 'hotelId'
                                });
                            }
                            break;
                        }
                        case 'extendedSearch': {
                            self.get('extendedSearchWidget').bindToScope(self._scopes.rootScope, $.extend({
                                'room': 'room',
                                'board' : 'board',
                                'rating': 'rating',
                                'maxPrice' : 'maxPrice',
                                'minPrice' : 'minPrice',
                                'maxRating' : 'maxRating',
                                'minRating' : 'minRating',
                                'category' : 'category'
                            }, GlobalTypeWidget.getScopeBindingMap()));
                            break;
                        }
                        case 'hotelSearchTagBar': {
                            self.get('hotelSearchTagBarWidget').bindToScope(self._scopes.rootScope, {
                                'hotelName': 'hotelName',
                                'productCode': 'productCode'
                            });
                            break;
                        }
                        default: {
                            throw new Error('Binding for parameter ' + name + ' not implemented.');
                            break;
                        }
                    }
                });
            }
        });

        return AbstractWidgetFactory;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/widgetfactory/abstractWidgetFactory.js